import React from 'react'
import { Grid, Card } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { selectGlobalDataState, setGeneralMessage, setTransactionHasBeenMade } from '../../../../../../features/global/globalDataSlice'
import { selectMyContractsState, resetSelectedContractInfo } from '../../../../../../features/myContracts/myContractsSlice'
import smallLoadingAnimation from '../../../../../../icons/lottieAnimations/smallLoading.json'
import Lottie from "lottie-react";
import OneInvoices from './OneInvoices'
import colors from '../../../../../colors'
import MyContractsTest from '../../myContracts/myContractsNew/MyContractsTest';
import { texts } from '../../../../../general/texts';
import { selectOneState, displayInvoiceList, displayMainUtilityView } from '../../../../../../features/oneMobile/oneSlice';
import SingleExpandedInvoice from '../../SingleExpandedInvoice';
import InvoiceList from '../../InvoiceList';
import OneSingleExpandedInvoice from './OneSingleExpandedInvoice';

const UtilityOneInvoices = (props) => {
    const oneInvoicesSliceState = useSelector(selectOneState)
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const dispatch = useDispatch()
    const utilityName = 'TELEKOM ALBANIA'

    const selectedButtonStyle =
    {
        backgroundColor: colors.lightOrange,
        color: colors.orange,
        paddingLeft: '21px',
        paddingRight: '21px',
        paddingTop: '6px',
        paddingBottom: '6px',
        fontWeight: 'bold',
        border: '2px solid' + colors.orange,
        borderRadius: '10px',
        '&:hover': {
            backgroundColor: colors.lightOrange
        }
    }

    const defaultButtonStyle =
    {
        backgroundColor: colors.lightBlue,
        paddingLeft: '21px',
        paddingRight: '21px',
        paddingTop: '6px',
        paddingBottom: '6px',
        borderRadius: '10px',
        color: colors.darkBlue,
        '&:hover': {
            backgroundColor: colors.lightOrange
        }
    }

    React.useEffect(() => {
        oneInvoicesSliceState.shouldDisplayInvoiceList && dispatch(displayInvoiceList())
        oneInvoicesSliceState.shouldDisplayMainUtilityView && dispatch(displayMainUtilityView())

        if (oneInvoicesSliceState.isTransactionSuccessfullyCompleted) {
            dispatch(setGeneralMessage({ type: 'success', message: texts["message-success-trx"] }))
            dispatch(setTransactionHasBeenMade(true))
        }

        return (() => {
            dispatch(resetSelectedContractInfo())
        })
    }, [oneInvoicesSliceState.isTransactionSuccessfullyCompleted, oneInvoicesSliceState.shouldDisplayInvoiceList, oneInvoicesSliceState.shouldDisplayMainUtilityView])

    return (
        <Grid container spacing={'2%'} pt={'3%'} >
            <Grid container item md={6.5} justifyContent={'right'} sx={{ '@media (max-width: 899px)': { justifyContent: 'center' } }} >
                <Card sx={{ borderRadius: '20px', boxShadow: '0 0 15px 5px #E5E7EA', width: '60%', '@media (max-width: 1440px )': { width: '70%' }, '@media (max-width: 1320px )': { width: '90%' } }}>
                    {oneInvoicesSliceState.shouldDisplayInvoiceList === false && oneInvoicesSliceState.shouldDisplaySingleInvoice === false && <OneInvoices selectedContractInfo={myContractsSliceState.selectedContractInfo} utilityName={utilityName} defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} oneInvoicesSliceState={oneInvoicesSliceState} utilityInfo={props.utilityInfo} globalDataSliceState={globalDataSliceState} />}
                    {oneInvoicesSliceState.shouldDisplayInvoiceList === true && <InvoiceList utilityInfo={props.utilityInfo} utilityName={utilityName} globalDataSliceState={globalDataSliceState} oneSliceState={oneInvoicesSliceState} invoices={oneInvoicesSliceState.invoiceList} />}
                    {oneInvoicesSliceState.shouldDisplaySingleInvoice === true && <OneSingleExpandedInvoice utilityName={utilityName} invoice={oneInvoicesSliceState.singleInvoice} globalDataSliceState={globalDataSliceState} oneSliceState={oneInvoicesSliceState} />}
                    <Grid container justifyContent={'center'}>
                        <Grid item md={3} xs={3}>{oneInvoicesSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true} />}</Grid>
                    </Grid>
                </Card>
            </Grid>
            <Grid container item md={4.5} justifyContent={'left'} sx={{ '@media (max-width: 899px)': { justifyContent: 'center' } }} >
                <MyContractsTest utilityName={utilityName} currentLocation='utility' />
            </Grid>
        </Grid>
    )
}

export default UtilityOneInvoices